/**
 * @generated SignedSource<<c159a7004b274dfe10b4131b0c521874>>
 * @relayHash d910e14528b778edccdf3346d4dd1cd7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8c5898b87be2785cd1fa98b9e26166f97cc871384be79e78648ac0054ab83525

import type { ConcreteRequest, Query } from 'relay-runtime';
export type DevOpsEnvironmentCategory = "DEVELOPMENT" | "PRODUCTION" | "STAGING" | "TESTING" | "UNMAPPED" | "%future added value";
export type JiraReleasesIssueReleaseStatusFilter = "RELEASED" | "RELEASED_AND_UNRELEASED" | "UNRELEASED" | "%future added value";
export type JiraReleasesIssueFilter = {
  assignees?: ReadonlyArray<string> | null | undefined;
  environmentCategories?: ReadonlyArray<DevOpsEnvironmentCategory | null | undefined> | null | undefined;
  environmentDisplayNames?: ReadonlyArray<string> | null | undefined;
  epicIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  fixVersions?: ReadonlyArray<string> | null | undefined;
  issueTypes?: ReadonlyArray<string> | null | undefined;
  projectId: string;
  releaseStatusFilter?: JiraReleasesIssueReleaseStatusFilter;
  text?: string | null | undefined;
  timeWindow: JiraReleasesTimeWindowInput;
};
export type JiraReleasesTimeWindowInput = {
  after: AGG$DateTime;
  before: AGG$DateTime;
};
export type mainIssueQuery$variables = {
  after?: string | null | undefined;
  filter: JiraReleasesIssueFilter;
  first: number;
};
export type mainIssueQuery$data = {
  readonly jiraReleases: {
    readonly issues: {
      readonly edges: ReadonlyArray<{
        readonly cursor: string;
        readonly node: {
          readonly assignee: {
            readonly __typename: string;
            readonly accountId: string;
            readonly name: string;
            readonly picture: AGG$URL;
          } | null | undefined;
          readonly epic: {
            readonly color: string | null | undefined;
            readonly id: string;
            readonly summary: string | null | undefined;
          } | null | undefined;
          readonly id: string;
          readonly issueKey: string | null | undefined;
          readonly issueTypeId: string | null | undefined;
          readonly summary: string | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      };
    } | null | undefined;
  } | null | undefined;
};
export type mainIssueQuery = {
  response: mainIssueQuery$data;
  variables: mainIssueQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v4 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v5 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "issueKey"
},
v8 = {
  "kind": "ScalarField",
  "name": "issueTypeId"
},
v9 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v10 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v11 = {
  "kind": "ScalarField",
  "name": "name"
},
v12 = {
  "kind": "ScalarField",
  "name": "picture"
},
v13 = {
  "kind": "ScalarField",
  "name": "summary"
},
v14 = {
  "concreteType": "JiraReleasesEpic",
  "kind": "LinkedField",
  "name": "epic",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v13/*: any*/),
    {
      "kind": "ScalarField",
      "name": "color"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "mainIssueQuery",
    "selections": [
      {
        "concreteType": "JiraReleases",
        "kind": "LinkedField",
        "name": "jiraReleases",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraReleasesIssueConnection",
            "kind": "LinkedField",
            "name": "issues",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "concreteType": "JiraReleasesIssueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  {
                    "concreteType": "JiraReleasesIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "assignee",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/)
                        ]
                      },
                      (v14/*: any*/),
                      (v13/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "mainIssueQuery",
    "selections": [
      {
        "concreteType": "JiraReleases",
        "kind": "LinkedField",
        "name": "jiraReleases",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraReleasesIssueConnection",
            "kind": "LinkedField",
            "name": "issues",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "concreteType": "JiraReleasesIssueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  {
                    "concreteType": "JiraReleasesIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "assignee",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v6/*: any*/)
                        ]
                      },
                      (v14/*: any*/),
                      (v13/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "8c5898b87be2785cd1fa98b9e26166f97cc871384be79e78648ac0054ab83525",
    "metadata": {},
    "name": "mainIssueQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d92a25ffb880dc1e08efe08905c98d12";

export default node;
